module.exports = __webpack_public_path__ + "img/icon-christmas-5.43140e80.svg";